import { Component, h } from '@stencil/core';

@Component({
  tag: 'loader-dots',
  styleUrl: 'loader-dots.css',
  shadow: true,
})
export class LoaderDots {
  render() {
    return <i></i>;
  }
}
